import React from 'react';
import { theme } from 'antd';

const Contact: React.FC = () => {
  const { token } = theme.useToken();

  return (
    <div style={{ padding: '96px 24px 24px' }}>
      <h1 style={{ fontSize: token.fontSizeHeading2, color: token.colorText, marginBottom: 16 }}>
        Contact
      </h1>
      <p style={{ fontSize: token.fontSize, color: token.colorTextSecondary, lineHeight: 1.6 }}>
        Have questions or feedback? We'd love to hear from you.
      </p>
      <p style={{ fontSize: token.fontSize, color: token.colorTextSecondary, lineHeight: 1.6, marginTop: 16 }}>
        Email us at: <a href="mailto:hello@spec.app" style={{ color: token.colorPrimary }}>hello@spec.app</a>
      </p>
    </div>
  );
};

export default Contact;
